import countUp from './js/countUp.min.js';

// alert('xx')
document.addEventListener( 'DOMContentLoaded', function () {
	const numbersIntersection = function ( entries ) {
		entries.forEach( function ( entry ) {
			if ( entry.isIntersecting ) {
				const numbers = entry.target.querySelectorAll( '.count-up' );
				numbers.forEach( function ( number ) {
					const counter = new countUp.CountUp(
						number,
						number.textContent
					);
					counter.start();
				} );
			}
		} );
	};
	const numbersObserver = new IntersectionObserver( numbersIntersection, {
		threshold: 0.5,
	} );
	document
		.querySelectorAll( '.wp-block-hmk-blocks-home-numbers' )
		.forEach( function ( section ) {
			numbersObserver.observe( section );
		} );
} );
